import React from 'react';
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';

import BackButton from '@ts-core/components/BackButton';
import PageContentLayout from '@ts-core/core/components/PageContentLayout';

import { useSubjectStats } from '@ts-core/modules/subjects/hooks';

import { SubjectWithStats } from '../../types/stats';
import { subjectWithStatsFragment } from '../../graphql/fragments';
import StudentSubjectStats from '../../components/SubjectStatsList';

const SubjectStatsPage = () => {
  const { courseId, subjectId } = useParams<{ courseId: string; subjectId: string }>();
  const { loading, subject } = useSubjectStats<SubjectWithStats>({ fragment: subjectWithStatsFragment, courseId, subjectId });

  return (
    <Box>
      <BackButton title={subject?.name} subtitle="Todos los temas" href={`/${courseId}/stats`} />
      <PageContentLayout>
        <StudentSubjectStats loading={loading} subject={subject} />
      </PageContentLayout>
    </Box>
  );
};

export default SubjectStatsPage;
